<ds-modal
  [modal]="modal"
  [title]="'mfa_modal_title' | translate"
  [maxWidthPercentage]="80"
  (modalClosed)="onCancel()"
  [closeAllModals]="false"
>
  <form [formGroup]="form">
    <div class="mfa-modal-body">
      {{ 'mfa_scan_this_qr_label' | translate }}
      <div class="d-flex qr">
        <img id="qr-image" alt="{{ 'mfa_qr_code' | translate }}" [src]="qrDataURL$ | async" />
      </div>
      <p>{{ 'mfa_enter_code_description' | translate }}</p>
      <app-common-input [form]="form" [context]="formContext"></app-common-input>
    </div>
  </form>
  <ng-template ds-modal-slide-out-footer>
    <ds-button-group
      [primaryAction]="{
        label: 'label_continue' | translate,
        disabled: form.invalid,
      }"
      [secondAction]="{ label: 'label_cancel' | translate, variant: DsButtonVariants.secondary }"
      (primaryActionClicked)="onContinue()"
      (secondActionClicked)="onCancel()"
    >
    </ds-button-group>
  </ng-template>
</ds-modal>
